import { render, staticRenderFns } from "./w-btn-back.vue?vue&type=template&id=6cb19e47&lang=pug&"
import script from "./w-btn-back.vue?vue&type=script&lang=js&"
export * from "./w-btn-back.vue?vue&type=script&lang=js&"
import style0 from "./w-btn-back.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/rain/projects/themes/achernar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6cb19e47')) {
      api.createRecord('6cb19e47', component.options)
    } else {
      api.reload('6cb19e47', component.options)
    }
    module.hot.accept("./w-btn-back.vue?vue&type=template&id=6cb19e47&lang=pug&", function () {
      api.rerender('6cb19e47', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/widgets/w-btn-back.vue"
export default component.exports